import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import KitchenListView from 'src/sections/kitchen/view/kitchen-list-view';

export default function KitchenListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Kitchen</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_KITCHEN_ITEM,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <KitchenListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
